export default {
      id: "vague_zoom-usage",
      viewBox: "0 0 405 26",
      url: "../dist/images/" + "sprite.svg#vague_zoom-usage",
      toString: function () {
        return this.url;
      }
    }